function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 62 62"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 3,
    y: 3,
    rx: 8,
    ry: 8,
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 9c-8.28 0-15 6.57-15 14.67S31 53 31 53s15-21.23 15-29.33S39.28 9 31 9m0 23.83c-5.18 0-9.38-4.1-9.38-9.17s4.2-9.17 9.38-9.17 9.38 4.1 9.38 9.17-4.2 9.17-9.38 9.17",
    style: {
      fill: "#333"
    }
  })));
};
export default SvgMapPin;